import classNames from 'classnames';
import { useMemo } from 'react';
import { calcPercentageDiff } from 'src/view/screens/ReportsScreen/helpers/reports';
import { formatPercentage, numberWithDigitSeparator } from '~/utils/formatter';

interface IProps {
  value: number | string;
  comparedValue?: number;
  className?: string;
  textClassName?: string;
}

const ReportTableField = ({ value, comparedValue, className, textClassName }: IProps) => {
  const percentageDiff: number | undefined = comparedValue ? calcPercentageDiff(Number(value), comparedValue) : undefined;

  const comparedValueClassName = useMemo((): string => {
    const color: string = percentageDiff && percentageDiff > 0 ? ' color-green' : ' color-red';
    return classNames('reports-table-string__field-comparing ml-2', textClassName, { [color]: percentageDiff });
  }, []);

  return (
    <div className={classNames('d-flex flex-row align-items-center pr-1 reports-table-string__field', className)}>
      <div className="d-flex full-width">
        <p className={classNames('reports-table-string__field-text text-elipsis', textClassName)}>
          {typeof value === 'string' ? value : numberWithDigitSeparator(Math.round(value))}
        </p>
        {comparedValue !== undefined ? (
          <span dir="ltr" className={comparedValueClassName}>
            {comparedValue !== 0 && percentageDiff !== undefined ? `(${formatPercentage(percentageDiff)}%)` : '(-)'}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default ReportTableField;
